import styled from 'styled-components';

import { media } from '@/utils/mediaQueries';

interface AddButtonStyledProps {
  $isSmall?: boolean;
  $iconOnly?: boolean;
  /** `light` = ten sam kształt i rozmiar, tylko biały (akcja drugorzędna obok „Dodaj nowy"). */
  $variant?: 'dark' | 'light';
}

export const AddButtonStyled = styled.button<AddButtonStyledProps>`
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ $isSmall }) => ($isSmall ? '6px' : '8px')};
  cursor: pointer;
  white-space: nowrap;
  font-weight: 500;
  font-size: ${({ $isSmall }) => ($isSmall ? '13px' : '14px')};
  line-height: 1;

  /* Klasyczny czarny przycisk w kształcie pigułki (pill); wariant 'light' jest biały. */
  color: ${({ $variant }) => ($variant === 'light' ? '#111827' : '#ffffff')};
  background: ${({ $variant }) => ($variant === 'light' ? '#ffffff' : '#111827')};
  border: 1px solid ${({ $variant }) => ($variant === 'light' ? '#d1d5db' : 'transparent')};
  border-radius: 9999px;
  box-shadow: ${({ $variant }) => ($variant === 'light'
    ? '0 1px 2px rgba(0, 0, 0, 0.06)'
    : '0 1px 2px rgba(0, 0, 0, 0.18)')};
  transition: background 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;

  height: ${({ $isSmall }) => ($isSmall ? '34px' : '38px')};
  width: ${({ $iconOnly, $isSmall }) => {
    if (!$iconOnly) return 'auto';
    return $isSmall ? '34px' : '38px';
  }};
  padding: ${({ $isSmall, $iconOnly }) => {
    if ($iconOnly) return '0';
    return $isSmall ? '0 14px' : '0 16px';
  }};

  /* Ikona w kolorze etykiety. */
  .icon {
    color: ${({ $variant }) => ($variant === 'light' ? '#111827' : '#ffffff')};
    width: ${({ $isSmall }) => ($isSmall ? '16px' : '18px')};
    height: ${({ $isSmall }) => ($isSmall ? '16px' : '18px')};
    flex-shrink: 0;
  }

  .label {
    color: ${({ $variant }) => ($variant === 'light' ? '#111827' : '#ffffff')};
  }

  &:hover {
    background: ${({ $variant }) => ($variant === 'light' ? '#f9fafb' : '#000000')};
    border-color: ${({ $variant }) => ($variant === 'light' ? '#9ca3af' : 'transparent')};
    box-shadow: ${({ $variant }) => ($variant === 'light'
    ? '0 2px 6px rgba(0, 0, 0, 0.10)'
    : '0 2px 6px rgba(0, 0, 0, 0.28)')};
  }

  &:active {
    transform: scale(0.97);
  }

  /* Telefon: sam plus w kole 36×36, napis zostaje tylko jako aria-label. */
  ${media.mobile} {
    width: 36px;
    height: 36px;
    padding: 0;
    flex-shrink: 0;

    .label {
      display: none;
    }
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  /* Dark mode — subtelna ramka, żeby czarny przycisk odcinał się od ciemnego tła.
     Wariant 'light' w ciemnym motywie jest „jaśniejszy od tła", a nie dosłownie biały. */
  ${({ theme, $variant }) => {
    if (theme.mode !== 'dark') return '';
    if ($variant === 'light') {
      return `
    background: #242a33;
    border-color: #4b5563;

    .icon, .label {
      color: #e5e7eb;
    }

    &:hover {
      background: #2f3742;
      border-color: #6b7280;
    }
  `;
    }
    return `
    background: #1f2937;
    border-color: #374151;

    &:hover {
      background: #111827;
    }
  `;
  }}
`;
